module.exports = __webpack_public_path__ + "img/hsbg.41b67c2b.jpg";